var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLargeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 47,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3536 48.3536C62.5488 48.1583 62.5488 47.8417 62.3536 47.6464L59.1716 44.4645C58.9763 44.2692 58.6597 44.2692 58.4645 44.4645C58.2692 44.6597 58.2692 44.9763 58.4645 45.1716L61.2929 48L58.4645 50.8284C58.2692 51.0237 58.2692 51.3403 58.4645 51.5355C58.6597 51.7308 58.9763 51.7308 59.1716 51.5355L62.3536 48.3536ZM32 48.5H62V47.5H32V48.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLargeWhite);
export default __webpack_public_path__ + "static/media/ArrowLarge_White.dfc9100656484a174dd5e9a2c5df53e1.svg";
export { ForwardRef as ReactComponent };